import log from '@/plugin/logger.ts'
const state = {  
  parcelList: [],                   // 조회된 배송상품목록
  newParcelList: [],                // 새로 등록할 배송상품목록


  tempConsolList: [],               // 임시 콘솔목록
  recentPackedOrders: [],           // 최근 포장완료 후 통합조회 반영이 필요한 목록
}


/********************************************************************** 
 * ******************************************************************** 
 * 가져오기 - getters
 * ********************************************************************
/**********************************************************************/
const getters = {
  /** 
   * 배송상품목록 가져오기
   * 
   */
  getParcelList(state) {
    // log.debug("[ Store / getParcelList ]  실행됨")
    let pl = state?.parcelList
    /** 비회원 표시처리 */
    if(pl.length > 0){
      pl.forEach((u) => {
        u.customerName = (u.customerName == null ? '비회원' : u.customerName)
      })
    }

    return pl
  },

  getNewList(state) {
    return state.newParcelList
  },

  getNewListCnt(state) {
    return state.newParcelList.length
  },

  getTempConsolList(state){
    log.debug("[ Store / getTempConsolList ] 실행됨")
    let pl = state.tempConsolList
    return pl
  },

  getRecentPackedOrders(state){
    return state.recentPackedOrders
  },
}



/********************************************************************** 
 * ******************************************************************** 
 * 변형 - mutation
 * ********************************************************************
/**********************************************************************/
const mutations = {

  /**
   * 일반 배송상품 목록
   * 
   * @param {*} state 
   * @param {*} value 
   */
  loadParcelList(state, value){
    // log.debug("loadParcelList excuted = > ", value)
    state.parcelList = value
  },
  // load more parcel list
  loadMoreParcelList(state, value){
    // log.debug("loadMoreParcelList excuted parcelList = > ", state.parcelList)
    // log.debug("loadMoreParcelList excuted value = > ", value )

    const oldArr = state.parcelList
    const moreArr = value

    oldArr.push( ...moreArr )

    state.parcelList = oldArr
  },



  /**
   * 배송상품등록
   * @param {*} state 
   * @param {*} value 
   */
  setNewParcelList(state, value){
    log.debug("setNewParcelList excuted")
    state.newParcelList.push(value)
  },

  clearNewParcelList(state){
    log.debug("clearNewParcelList")
    state.newParcelList = []
  },

  

  removeParcelFromList(state, value){
    log.debug("removeParcelFromList excuted = >" + value)
    state.newParcelList.splice(value, 1)
  },

  initNewParcelList(state, value){
    log.debug("initNewParcelList excuted = >" + value)
    state.newParcelList = []
  },

  modifyParcelInfoFromList(state, value){

    log.debug("modifyParcelInfoFromList excuted = >", value)

    let tempArr = state.newParcelList
    let idx = value.idx
    let modifiedData = value.data

    const newArr = tempArr.map((item, i) => {
      // log.debug("item = ", item)
      // log.debug("modifiedData = ", modifiedData)
      // log.debug("return = ", { ...item, ...modifiedData })
      if(idx === i){
        log.debug("found array")
        return { ...item, ...modifiedData }
      }
      return item
    })

    state.newParcelList = newArr
  },

  /** 임시 콘솔목록에 추가 */
  patchTempConsolList(state, value){
    log.debug("[ Store / parcel / mutation ] patchTempConsolList excuted = > ", value)
    
    // arr1 -> arr2 순서 유지, arr2에서 id 중복된 값은 추가 안함
    const map = new Map();
    [...state.tempConsolList, ...value].forEach(item => {
      if (!map.has(item.id)) {
        map.set(item.id, item);
      }
    });

    state.tempConsolList = Array.from(map.values());
  },
  
  /** 임시 콘솔목록 삭제 */
  clearTempConsolList(state){
    state.tempConsolList = []
  },

  addRecentPackedOrder(state, value){
    if (!value || !value.orderNo) return

    const next = {
      ...value,
      packedAt: value.packedAt || new Date().toISOString()
    }

    const map = new Map()
    ;[next, ...state.recentPackedOrders].forEach(item => {
      if (!item.orderNo) return
      if (!map.has(item.orderNo)) {
        map.set(item.orderNo, item)
      }
    })

    state.recentPackedOrders = Array.from(map.values()).slice(0, 30)
  },

  setRecentPackedOrders(state, value){
    state.recentPackedOrders = Array.isArray(value) ? value : []
  },

  clearRecentPackedOrders(state){
    state.recentPackedOrders = []
  },

  removeRecentPackedOrders(state, orderNos){
    const targets = new Set((orderNos || []).map(item => String(item)))
    state.recentPackedOrders = state.recentPackedOrders.filter(item => !targets.has(String(item.orderNo)))
  },

  patchParcelRows(state, rows){
    if (!Array.isArray(rows) || rows.length === 0) return

    const rowMap = new Map(rows.map(row => [String(row.orderId), row]))
    state.parcelList = state.parcelList.map(item => {
      const patched = rowMap.get(String(item.orderId))
      return patched ? { ...item, ...patched } : item
    })
  },
}


/********************************************************************** 
 * ******************************************************************** 
 * 액션 - actions
 * ********************************************************************
/**********************************************************************/
const actions = {
  /**
   * 일반 배송목록
   * @param {*} param0 
   * @param {*} payload 
   */
  loadParcel: ({ commit }, payload) => {
    // log.debug(state)
    commit('loadParcelList', payload)
  },
  loadMoreParcel: ({ commit }, payload) => {
    // log.debug(state)
    commit('loadMoreParcelList', payload)
  },


  /*****************************************
   * 신규등록 배송상품
   * @param {*} param0 
   * @param {*} payload 
   *****************************************/
  fetchNewParcel: ({ commit }, payload) => {
    // log.debug(state)
    commit('setNewParcelList', payload)
  },

  clearNewParcelList: ({ commit }) => {
    // log.debug(state)
    commit('clearNewParcelList')
  },

  removeNewParcel: ({ commit }, payload) => {
    // log.debug(state)
    commit('removeParcelFromList', payload)
  },
  initNewParcel: ({ commit }, payload) => {
    // log.debug(state)
    commit('initNewParcelList', payload)
  },
  modifyParcelInfo: ({ commit }, payload) => {
    // log.debug(state)
    commit('modifyParcelInfoFromList', payload)
  },
  /** 임시 콘솔목록에 추가 */
  actListingTempConsolList: ({ commit }, payload) => {
    log.debug("[ Store / parcel / actions ] listingTempConsolList excuted = > ", payload)
    commit('patchTempConsolList', payload)
  },

  /** 임시 콘솔목록 삭제 */
  clearTempConsolList: ({ commit }) => {
    commit('clearTempConsolList')
  },

  addRecentPackedOrder: ({ commit }, payload) => {
    commit('addRecentPackedOrder', payload)
  },

  setRecentPackedOrders: ({ commit }, payload) => {
    commit('setRecentPackedOrders', payload)
  },

  clearRecentPackedOrders: ({ commit }) => {
    commit('clearRecentPackedOrders')
  },

  removeRecentPackedOrders: ({ commit }, payload) => {
    commit('removeRecentPackedOrders', payload)
  },

  patchParcelRows: ({ commit }, payload) => {
    commit('patchParcelRows', payload)
  },
}


// state, getters, mutations, actions, modules
export default {

  state: {
    ...state
  },
  getters,
  mutations,
  actions

}
